import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { MantineProvider, createTheme } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/Layout/AdminLayout';
import MemberLayout from './components/Layout/MemberLayout';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import BatchManager from './pages/admin/BatchManager';
import MemberManager from './pages/admin/MemberManager';
import BatchSettings from './pages/admin/BatchSettings';
import ClassesManager from './pages/admin/ClassesManager';
import CurriculumManager from './pages/admin/CurriculumManager';
import MemberLogin from './pages/member/MemberLogin';
import MemberDashboard from './pages/member/MemberDashboard';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
/* import AutoLoginHandler from './components/AutoLoginHandler'; */
// Add import
import AutoLoginSuccess from './components/AutoLoginSuccess';
//import Certificate from './components/member/Certificate'; // Import the Certificate component


const theme = createTheme({
  primaryColor: 'blue',
  fontFamily: 'Open Sans, sans-serif',
});

function App() {
  return (
    <MantineProvider theme={theme}>
      <Notifications />
      <AuthProvider>
        <Router>
          <Routes>

            <Route path="/member/auto-login-success" element={<AutoLoginSuccess />} />
            <Route path="/" element={<Navigate to="/member/login" replace />} />

            {/* Admin routes */}
            <Route path="/admin/login" element={<AdminLogin />} />

            <Route
              path="/admin/*"
              element={
                <ProtectedRoute requiredUserType="admin">
                  <AdminLayout>
                    <Routes>
                      <Route path="dashboard" element={<AdminDashboard />} />
                      <Route path="batches" element={<BatchManager />} />
                      <Route path="members" element={<MemberManager />} />
                      <Route path="settings" element={<BatchSettings />} />
                      <Route path="classes" element={<ClassesManager />} />
                      <Route path="curriculum" element={<CurriculumManager />} />
                      <Route path="*" element={<Navigate to="/admin/dashboard" replace />} />
                    </Routes>
                  </AdminLayout>
                </ProtectedRoute>
              }
            />

            {/* Member routes */}
            <Route path="/member/login" element={<MemberLogin />} />

            <Route
              path="/member/*"
              element={
                <ProtectedRoute requiredUserType="member">
                  <MemberLayout>
                    <Routes>
                      {/* <Route path="certificate" element={<Certificate />} /> */}
                      <Route path="dashboard" element={<MemberDashboard />} />
                      <Route path="*" element={<Navigate to="/member/dashboard" replace />} />
                    </Routes>
                  </MemberLayout>
                </ProtectedRoute>
              }
            />

            {/* Catch all */}
            <Route path="*" element={<Navigate to="/member/login" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </MantineProvider>
  );
}

export default App;